import lazyWithRetry from '../functions/lazyWithRetry';
import withLazyIconFallback from './withLazyIconFallback';


const IconArrowLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconArrow'))
);
const IconAwardLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconAward'))
);
const IconBarChartLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconBarChart'))
);
const IconBellLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconBell'))
);
const IconBookLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconBook'))
);
const IconBriefcaseLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconBriefcase'))
);
const IconCalculatorLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCalculator'))
);
const IconCalendarLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCalendar'))
);
const IconCakeLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCake'))
);
const IconCarLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCar'))
);
const IconCartLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCart'))
);
const IconCheckmarkLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCheckmark'))
);
const IconClockLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconClock'))
);
const IconConversationLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconConversation'))
);
const IconCreditCardLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconCreditCard'))
);
const IconDiamondLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconDiamond'))
);
const IconDollarLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconDollar'))
);
const IconExclamationMarkLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconExclamationMark'))
);
const IconEyeLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconEye'))
);
const IconFiltersLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconFilters'))
);
const IconGarbageLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconGarbage'))
);
const IconGasTankLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconGasTank'))
);
const IconGhostLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconGhost'))
);
const IconGiftLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconGift'))
);
const IconHeadsetLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconHeadset'))
);
const IconHeartLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconHeart'))
);
const IconHourglassLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconHourglass'))
);
const IconHouseLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconHouse'))
);
const IconKeyLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconKey'))
);
const IconLifePreserverLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconLifePreserver'))
);
const IconLightBulbLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconLightBulb'))
);
const IconLightningLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconLightning'))
);
const IconLockLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconLock'))
);
const IconMailOpenLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconMailOpen'))
);
const IconMapleLeafLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconMapleLeaf'))
);
const IconMapPinLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconMapPin'))
);
const IconMicrophoneLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconMicrophone'))
);
const IconMinusLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconMinus'))
);
const IconNoDollarLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconNoDollar'))
);
const IconNoteLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconNote'))
);
const IconPaperLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPaper'))
);
const IconPaperStackLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPaperStack'))
);
const IconPeopleLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPeople'))
);
const IconPersonLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPerson'))
);
const IconPhoneLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPhone'))
);
const IconPiggyLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPiggy'))
);
const IconPlaneLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPlane'))
);
const IconPlusLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPlus'))
);
const IconPodcastMicrophoneLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconPodcastMicrophone'))
);
const IconQuestionMarkLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconQuestionMark'))
);
const IconRatehubLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconRatehub'))
);
const IconRefreshLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconRefresh'))
);
const IconRobotLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconRobot'))
);
const IconSearchLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconSearch'))
);
const IconShareLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconShare'))
);
const IconShieldLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconShield'))
);
const IconSmileLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconSmile'))
);
const IconSpeechBubbleLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconSpeechBubble'))
);
const IconSpeedometerLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconSpeedometer'))
);
const IconStarLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconStar'))
);
const IconStudentLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconStudent'))
);
const IconSuitcaseLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconSuitcase'))
);
const IconThumbsDownLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconThumbsDown'))
);
const IconThumbsUpLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconThumbsUp'))
);
const IconTrendingLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconTrending'))
);
const IconTrophyLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconTrophy'))
);
const IconUmbrellaLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconUmbrella'))
);
const IconUserLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconUser'))
);
const IconVideoLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconVideo'))
);
const IconWalletLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconWallet'))
);
const IconWrenchLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconWrench'))
);
const IconXLazy = withLazyIconFallback(
    lazyWithRetry(() => import('./icons/IconX'))
);

export {
    IconArrowLazy,
    IconAwardLazy,
    IconBarChartLazy,
    IconBellLazy,
    IconBookLazy,
    IconBriefcaseLazy,
    IconCalculatorLazy,
    IconCalendarLazy,
    IconCakeLazy,
    IconCarLazy,
    IconCartLazy,
    IconCheckmarkLazy,
    IconClockLazy,
    IconConversationLazy,
    IconCreditCardLazy,
    IconDiamondLazy,
    IconDollarLazy,
    IconExclamationMarkLazy,
    IconEyeLazy,
    IconFiltersLazy,
    IconGarbageLazy,
    IconGasTankLazy,
    IconGhostLazy,
    IconGiftLazy,
    IconHeadsetLazy,
    IconHeartLazy,
    IconHourglassLazy,
    IconHouseLazy,
    IconKeyLazy,
    IconLifePreserverLazy,
    IconLightBulbLazy,
    IconLightningLazy,
    IconLockLazy,
    IconMailOpenLazy,
    IconMapleLeafLazy,
    IconMapPinLazy,
    IconMicrophoneLazy,
    IconMinusLazy,
    IconNoDollarLazy,
    IconNoteLazy,
    IconPaperLazy,
    IconPaperStackLazy,
    IconPeopleLazy,
    IconPersonLazy,
    IconPhoneLazy,
    IconPiggyLazy,
    IconPlaneLazy,
    IconPlusLazy,
    IconPodcastMicrophoneLazy,
    IconQuestionMarkLazy,
    IconRatehubLazy,
    IconRefreshLazy,
    IconRobotLazy,
    IconSearchLazy,
    IconShareLazy,
    IconShieldLazy,
    IconSmileLazy,
    IconSpeechBubbleLazy,
    IconSpeedometerLazy,
    IconStarLazy,
    IconStudentLazy,
    IconSuitcaseLazy,
    IconThumbsDownLazy,
    IconThumbsUpLazy,
    IconTrendingLazy,
    IconTrophyLazy,
    IconUmbrellaLazy,
    IconUserLazy,
    IconVideoLazy,
    IconWalletLazy,
    IconWrenchLazy,
    IconXLazy,
};
